module.exports = __webpack_public_path__ + "img/2PC.15985eaa.png";